/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
export default {
  rowMinHeight: 74,
  defaultPopIfNotAvailable: '0',
  noWeatherIconWhite: 'static/img/noweather-white.svg',
  noWeatherIcon: 'static/img/noweather.svg',
  weatherType: [{
    key: 'tstorms',
    icon: 'wi-thunderstorm',
    regex: 'tsra',
  }, {
    key: 'snow',
    icon: 'wi-day-snow',
    regex: 'snow|sn',
  }, {
    key: 'sleet',
    icon: 'wi-sleet',
    regex: 'sleet',
  }, {
    key: 'fog',
    icon: 'wi-fog',
    regex: 'fog|foggy',
    customStyle: { 'margin-top': '0px' },
  }, {
    key: 'rain',
    icon: 'wi-rain',
    regex: 'rain|ra',
    customStyle: { 'margin-top': '0px' },
  }, {
    key: 'showers',
    icon: 'wi-day-showers',
    regex: 'shra|shower|shwrs',
    customStyle: { 'margin-top': '0px' },
  }, {
    key: 'wind',
    icon: 'wi-day-windy',
    regex: 'wind',
  }, {
    key: 'cloudy',
    icon: 'wi-day-cloudy',
    regex: 'bkn|broken',
    customStyle: { 'margin-top': '-10px' },
  }, {
    key: 'ovccloud',
    icon: 'wi-cloudy',
    regex: 'ovc',
    customStyle: { 'margin-top': '0px' },
  }, {
    key: 'partlycloudy',
    icon: 'wi-day-sunny-overcast',
    regex: 'sct|partly-cloudy-day|partly-cloudy-night|cloudy',
    customStyle: { 'margin-top': '0px' },
  }, {
    key: 'sunny',
    icon: 'wi-day-sunny',
    regex: 'few|skc|clear-day|cold|hot',
    customStyle: { 'margin-top': '-5px' },
  }, {
    key: 'default',
    icon: 'default-weather',
    keywords: [],
  }],
  weatherMapping: {
    lightning: {
      key: 1,
      filename: 'lightning',
      levelOfWeather: 1,
    },
    freezing: {
      key: 2,
      filename: 'freezing',
      levelOfWeather: 2,
    },
    highSnow: {
      key: 3,
      filename: 'high-snow',
      levelOfWeather: 4,
    },
    highSnowHighPrecipitation: {
      key: 4,
      filename: 'high-snow-high-precipitation',
      levelOfWeather: 3,
    },
    mediumSnowHighPrecipitation: {
      key: 5,
      filename: 'medium-snow-high-precipitation',
      levelOfWeather: 6,
    },
    lowSnowMediumPrecipitation: {
      key: 6,
      filename: 'low-snow-medium-precipitation',
      levelOfWeather: 8,
    },
    lowCeilingLowVisibilityDay: {
      key: 7,
      filename: 'low-ceiling-low-visibility-day',
      levelOfWeather: 9,
    },
    lowCeilingLowVisibilityNight: {
      key: 7,
      filename: 'low-ceiling-low-visibility-night',
      levelOfWeather: 9,
    },
    highWind: {
      key: 8,
      filename: 'high-wind',
      levelOfWeather: 10,
    },
    cloudy: {
      key: 9,
      filename: 'cloudy',
      levelOfWeather: 11,
    },
    scatteredCloudDay: {
      key: 10,
      filename: 'scattered-cloud-day',
      levelOfWeather: 12,
    },
    sunny: {
      key: 11,
      filename: 'sunny',
      levelOfWeather: 13,
    },
    lowPrecipMediumSnow: {
      key: 12,
      filename: 'low-precip-medium-snow',
      levelOfWeather: 5,
    },
    night: {
      key: 13,
      filename: 'night',
      levelOfWeather: 13,
    },
    scatteredCloudNight: {
      key: 14,
      filename: 'scattered-cloud-night',
      levelOfWeather: 12,
    },
    rainFog: {
      key: 15,
      filename: 'rain-fog',
      levelOfWeather: 7,
    },
  },
};
